import { Link } from "react-router-dom";

const ALL = {
  "/cabana-rentals": "Riverside Cabana Rentals",
  "/cabins": "River Cabins",
  "/day-passes": "Day Passes",
  "/day-trip": "Texas River Day Trip",
  "/day-rentals": "Day Rentals",
  "/stay-overnight": "Stay Overnight",
} as const;

type Path = keyof typeof ALL;

/** Small "Explore more" link row placed above the footer to strengthen internal linking. */
const ExploreLinks = ({ links, title = "Explore more at Son's Blue River" }: { links: Path[]; title?: string }) => (
  <nav aria-label="Explore more" className="container mx-auto px-4 py-8 text-center">
    <p className="font-heading text-lg font-semibold text-foreground mb-3">{title}</p>
    <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2">
      {links.map((to) => (
        <li key={to}>
          <Link to={to} className="text-river underline underline-offset-4 hover:opacity-80">
            {ALL[to]}
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);

export default ExploreLinks;
